<style scoped>

</style>

<template>
    <div>
        <h1>活动开关：{{catActivityDetail.catName}}</h1>
        <div class="activity-switch">
            <div class="label">当前开启状态：</div>
            <div class="switch-item">
                <el-switch v-model="catActivityDetail.activitySwitch" :active-value="1" :inactive-value="2" active-text="运行" inactive-text="停止"></el-switch>
            </div>
        </div>
        <div class="label">允许选项</div>
        <div>
            <div class="switch-item" v-for="(item,index) in catActivityDetail.catPanelList" :key="index">
                <el-switch v-model="item.panelSwitch" :active-value="1" :inactive-value="2" :active-text="item.panelName"></el-switch>
            </div>
        </div>
        <div class="label">指定操作机位</div>
        <el-select v-model="catActivityDetail.cameraId" placeholder="请选择" size="mini" style="width:200px;">
            <el-option
            v-for="item in cameraList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        <div class="label">操作开始时间</div>
        <el-time-picker size="mini" style="width:200px;"
            v-model="catActivityDetail.operateStartTime"
            :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '23:59'
            }"
            format="HH:mm"
            value-format="HHmm"
            placeholder="选择时间">
            </el-time-picker>
        <div class="label">操作间隔（分钟）</div>
        <el-input size="mini" style="width:200px;" type="number" :min="1" :max="60"
            v-model="catActivityDetail.operateConsumeTime" placeholder="请输入时间间隔">
        </el-input>

        <br></br>
        <div>
            <el-button type="primary" @click="saveActivitySwitch">保存配置</el-button>
        </div>
    </div>
</template>

<script>
import { getCatActivityDetail, saveActivitySwitch } from '@/request/api';
export default {
    name: 'ActivitySwitch',
    data() {
      return {
        catId: 0,
        cameraList: [{
            label: '1号机位',
            value: 1
        },{
            label: '2号机位',
            value: 2
        },{
            label: '3号机位',
            value: 3
        },{
            label: '4号机位',
            value: 4
        },{
            label: '5号机位',
            value: 5
        },{
            label: '6号机位',
            value: 6
        }],
        catActivityDetail: {
            catPanelList: []
        }
      };
    },
    methods: {
      getCatActivityDetail() {
        getCatActivityDetail({
            catId: this.catId
        }).then(res => {
            var status = res.status;
            var msg = res.msg;
            if (status === '2') {
                this.$message.error(msg);
            } else {
                this.$message.success("查询成功");
                var data = res.data;
                this.catActivityDetail = data;
            }
        })
      },
      saveActivitySwitch() {
          var params = this.catActivityDetail 
          saveActivitySwitch(
              params
          ).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("保存成功");
                    setTimeout(() => {                        
                         this.getCatActivityDetail();                  
                     }, 1000);        
                    
                }
            })
      }
    },
    created(){
        var catId = this.$route.query.catId
        console.log(catId);
        this.catId = catId;
        this.getCatActivityDetail();
    }
}
</script>

<style scoped>
.activity-switch {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 10px;
}
.label {
  font-size: 16px;
  width: 200px;
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
}
.switch-item {
    width: 200px;
    height: 30px;
    line-height: 30px;
    margin-left: 10px;
}
</style>




// WEBPACK FOOTER //
// src/page/activity/activitySwitch.vue